// base styles
  import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import colors from "assets/mavric-theme/base/colors";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { size, fontWeightMedium } = typography;
const { borderRadius } = borders;
const { dark, primary } = colors;

const tab = {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: "1 1 auto",
      textAlign: "center",
      maxWidth: "unset !important",
      minWidth: "unset !important",
      minHeight: "unset !important",
      fontSize: size.xs,
      fontWeight: fontWeightMedium,
      textTransform: "none",
      lineHeight: "inherit",
      //padding: pxToRem(2),
      //borderRadius: borderRadius.lg,
      color: `${primary.focus}`,
      opacity: "1 !important",

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
        color: `${primary.focus}`,
      },
    },

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};

export default tab;
